import React, { useEffect, useState } from 'react';
import './OrientationLock.css';
import { isPhysicalMobileGameViewport } from './utils/isPhysicalMobileGameViewport';

function isElectronClient() {
  return (
    typeof window !== 'undefined' &&
    (window.location.protocol === 'file:' || window.electron !== undefined)
  );
}

function shouldBlockWebMobile() {
  if (isElectronClient()) return false;
  return isPhysicalMobileGameViewport();
}

/**
 * Web: blocks handheld/touch small viewports (game not supported on mobile yet).
 * Otherwise: locks to landscape and shows rotate prompt in portrait (existing behavior).
 * Electron is never blocked here.
 */
function OrientationLock({ children }) {
  const [isPortrait, setIsPortrait] = useState(false);
  const [mobileBlocked, setMobileBlocked] = useState(() => shouldBlockWebMobile());

  useEffect(() => {
    const check = () => {
      setMobileBlocked(shouldBlockWebMobile());
      const isPortraitMode = window.innerWidth < window.innerHeight;
      setIsPortrait(isPortraitMode);
    };

    check();

    window.addEventListener('resize', check);
    window.addEventListener('orientationchange', check);

    if (screen.orientation && screen.orientation.lock) {
      screen.orientation.lock('landscape').catch(() => {});
    }

    return () => {
      window.removeEventListener('resize', check);
      window.removeEventListener('orientationchange', check);
      document.body.classList.remove('orientation-locked');
    };
  }, []);

  useEffect(() => {
    if (mobileBlocked || isPortrait) {
      document.body.classList.add('orientation-locked');
    } else {
      document.body.classList.remove('orientation-locked');
    }
    return () => {
      document.body.classList.remove('orientation-locked');
    };
  }, [mobileBlocked, isPortrait]);

  if (mobileBlocked) {
    return (
      <div className="orientation-lock-message">
        <div className="orientation-lock-content">
          <h2>Desktop required</h2>
          <p>CODA is not supported on phones and tablets yet.</p>
          <p>Please play in a desktop or laptop web browser.</p>
        </div>
      </div>
    );
  }

  if (isPortrait) {
    return (
      <div className="orientation-lock-message">
        <div className="orientation-lock-content">
          <h2>Please Rotate Your Device</h2>
          <p>This game requires landscape orientation.</p>
          <p>Please rotate your device to continue.</p>
          <div className="orientation-lock-icon">📱</div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}

export default OrientationLock;
